angular.module('echarts', []);
angular.module('echarts')
    .directive('echarts', [
        function () {
            return {
                templateUrl: '',
                restrict: 'A',
                scope: {
                    options: '=chartOptions',
                },
                link: function ($scope, element) {
                    const chart = echarts.init(element[0]);

                    // apply options on init
                    if (_.isObject($scope.options)) {
                        chart.setOption($scope.options);
                    }

                    const optionsWatcher = $scope.$watch('options', function (cur, prev) {
                        if (cur && !_.isEqual(prev, cur) && chart) {
                            chart.setOption($scope.options);
                        }
                    })

                    element.on('$destroy', function () {
                        optionsWatcher && optionsWatcher();
                    });
                }
            }
        }]);
